import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from "redux";
import ProductAdaptee from "../../../../../adapters/product/ProductAdaptee";
import ProductAdapter from "../../../../../adapters/product/ProductAdapter";
import Config from "../../../../../config/config";
import ActionTypes from "../../../../../constants/ActionTypes";
import { getItem, setItem } from "../../../../../utilites/localStorage";
import Validator from "../../../../../validators/Validator";
import { setRecentlyViewedProductInLocalStorage, setRecentlyViewedProducts } from "./actions";

const recentlyViewedProductsMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);

  switch (action.type) {
  case ActionTypes.PRODUCT.TRANSFORM_PRODUCT_RESPONSE:
    const productCopy = { ...store.getState().productData.product.item };
    const productAdaptee = (new ProductAdapter(productCopy, new ProductAdaptee())).transform();
    store.dispatch(setRecentlyViewedProductInLocalStorage(productAdaptee));
    break;
  case ActionTypes.PRODUCT.SET_RECENTLY_VIEWED_IN_LOCAL_STORAGE:
    const products = getItem('recentlyViewedProducts', '[]');
    const product = products.find((item: any) => item.id === action.payload.product.id);
    if (Validator.isUndefined(product) && products.length < Config.recentlyViewedProductsLimit) {
      products.push(action.payload.product);
      setItem('recentlyViewedProducts', products);
    }
    break;
  case ActionTypes.PRODUCT.GET_RECENTLY_VIEWED:
    const localStorageProducts = getItem('recentlyViewedProducts', '[]');
    if (localStorageProducts.length) {
      next(setRecentlyViewedProducts(localStorageProducts));
    }
    break;
  }
};

export default recentlyViewedProductsMiddleware;
